import { render, staticRenderFns } from "./SearchPublisherFilter.vue?vue&type=template&id=0d015525&"
import script from "./SearchPublisherFilter.vue?vue&type=script&lang=js&"
export * from "./SearchPublisherFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports